/**
 * Resolve cliente vinculado à pré-venda no caixa.
 * Usa customer_id da venda mesmo se a API de clientes falhar (ex.: permissão).
 */

export function extractSaleCustomerId(source) {
  if (!source) return null
  const raw = source.customer_id ?? source.customerId
  if (raw == null || raw === '') return null
  const n = Number(raw)
  if (Number.isFinite(n) && n > 0) return n
  return raw
}

export function buildCustomerStub(customerId, name) {
  if (!customerId) return null
  return {
    id: customerId,
    name: name || 'Cliente'
  }
}

/**
 * @param {object} presaleData - resposta getById da pré-venda
 * @param {object} [listItem] - item da lista "aguardando" (fallback de nome/id)
 * @param {function} fetchCustomerById - async (id) => { success, data }
 */
export async function resolveCustomerForCaixa(presaleData, listItem, fetchCustomerById) {
  const customerId =
    extractSaleCustomerId(presaleData) || extractSaleCustomerId(listItem)

  if (!customerId) {
    return { customer: null, customerId: null }
  }

  const stubName =
    presaleData?.customer_name ??
    presaleData?.customerName ??
    listItem?.customer_name ??
    listItem?.customerName ??
    'Cliente'

  if (typeof fetchCustomerById === 'function') {
    try {
      const customerResponse = await fetchCustomerById(customerId)
      if (customerResponse?.success && customerResponse.data) {
        const data = customerResponse.data
        const id = data.id ?? data.customer_id ?? customerId
        return {
          customer: { ...data, id },
          customerId: id
        }
      }
    } catch (error) {
      console.warn(
        '[Caixa] Cliente não carregado pela API; usando dados da pré-venda:',
        error
      )
    }
  }

  return {
    customer: buildCustomerStub(customerId, stubName),
    customerId
  }
}

export function getEffectiveCustomerId(selectedCustomer, saleCustomerId) {
  const fromCustomer =
    selectedCustomer?.id ?? selectedCustomer?.customer_id ?? null
  if (fromCustomer != null && fromCustomer !== '') return fromCustomer
  return saleCustomerId ?? null
}
